import { c as _c } from "react/compiler-runtime";
import IconGitHub from '@/components/assets/icon_github.svg';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import ViverseButton from '@/components/ViverseButton';
import { useCheckEnterRoomContext } from '@/context/CheckEnterRoomContext';
import { Link } from '@/i18n/navigation';
import { cn } from '@/lib/utils';
import { useTranslations } from 'next-intl';
type GithubButtonProps = {
  className?: string;
  iconClassName?: string;
};
export default function GithubButton(t0) {
  const $ = _c(17);
  const {
    className,
    iconClassName
  } = t0;
  const t = useTranslations();
  const {
    roomData
  } = useCheckEnterRoomContext();
  const githubUrl = roomData.github_url;
  const isShowButton = githubUrl && githubUrl.length > 0;
  if (!isShowButton) {
    return null;
  }
  let t1;
  if ($[0] !== className) {
    t1 = cn("shrink-0", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== iconClassName) {
    t2 = <IconGitHub className={iconClassName} />;
    $[2] = iconClassName;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== githubUrl || $[5] !== t2) {
    t3 = <Link href={githubUrl} target="_blank">{t2}</Link>;
    $[4] = githubUrl;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t1 || $[8] !== t3) {
    t4 = <TooltipTrigger asChild={true}><ViverseButton asChild={true} className={t1} variant="filter" size="custom">{t3}</ViverseButton></TooltipTrigger>;
    $[7] = t1;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t) {
    t5 = t("github-button.tips");
    $[10] = t;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t5) {
    t6 = <TooltipContent side="top" align="center" className="bg-sidebar-primary">{t5}</TooltipContent>;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t4 || $[15] !== t6) {
    t7 = <Tooltip>{t4}{t6}</Tooltip>;
    $[14] = t4;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
}